import { Box, Flex } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const SkeletonCard = () => {
  return (
    <Box className={styles['card-promo-host__skeleton']}>
      <Flex width="100%" gap="4px" direction="column">
        <Flex width="100%" gap="8px">
          <SkeletonComponent height="21px" width="20%" mb="2px" />
          <SkeletonComponent height="21px" width="20%" mb="2px" />
        </Flex>
        <SkeletonComponent height="21px" width="80%" mb="2px" />
        <SkeletonComponent height="21px" width="70%" mb="2px" />
      </Flex>
    </Box>
  );
};

const CardPromoSkeleton = () => {
  return (
    <Box className={styles['card-promo-host__skeleton--container']} data-testid="card-promo__skeleton">
      <Iteration items={Array.from({ length: 6 })} render={() => <SkeletonCard />} />
    </Box>
  );
};

export default CardPromoSkeleton;
